module.exports = __webpack_public_path__ + "img/absorbente10.504d6d30.jpg";